import { ChartType } from '@enums/chart-type.enum';

import { ReportDataType } from '@enums/report-data-type.enum';

import { ReportStack } from './report-stack';
import { ApiText } from '@classes/api-text';

export class ReportVariation {
    code: string;
    labels: string[];
    axesLabels?: {
        categories: string;
        data: string;
    };

    displayType: ChartType;
    dataType: ReportDataType;
    text?: ApiText;
    stacks: ReportStack[];

    constructor(displayType: ChartType) {
        this.displayType = displayType;

        this.dataType = ReportDataType.amount;

        this.labels = [];
        this.stacks = [];
    }
}
